import { render, staticRenderFns } from "./changegallery.vue?vue&type=template&id=3c039d0a&scoped=true"
import script from "./changegallery.vue?vue&type=script&lang=js"
export * from "./changegallery.vue?vue&type=script&lang=js"
import style0 from "./changegallery.vue?vue&type=style&index=0&id=3c039d0a&scoped=true&lang=scss"
import style1 from "./changegallery.vue?vue&type=style&index=1&id=3c039d0a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c039d0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c039d0a')) {
      api.createRecord('3c039d0a', component.options)
    } else {
      api.reload('3c039d0a', component.options)
    }
    module.hot.accept("./changegallery.vue?vue&type=template&id=3c039d0a&scoped=true", function () {
      api.rerender('3c039d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gallery/changegallery.vue"
export default component.exports